/* eslint-disable */

export const STAGE_THEMES = {
  'Drawing stage': {
    color: 'var(--gold)', light: '#fdf8f0', dark: '#b8934a'
  },
  'Hand made sample stage': {
    color: '#4a7fa5', light: '#f0f7fc', dark: '#2d6080'
  },
  'Color sample stage': {
    color: '#b8896e', light: '#faf0e4', dark: '#84502e'
  },
  'Completed':       { color: '#5a9e7c', light: '#eaf5ef', dark: '#2d6648' },
  'Done':            { color: '#5a9e7c', light: '#eaf5ef', dark: '#2d6648' },
  'Completed stage': { color: '#5a9e7c', light: '#eaf5ef', dark: '#2d6648' },
  'Done stage':      { color: '#5a9e7c', light: '#eaf5ef', dark: '#2d6648' },
  'Cancelled':       { color: '#c0392b', light: '#fdf0ef', dark: '#a93226' },
  'Paused':          { color: '#d4a017', light: '#fdf8e8', dark: '#b8860b' },
  'Moved to order':  { color: '#dc9d74', light: '#fdf5ef', dark: '#8a4f26' },   // Collection C2 — apricot copper (D1, Addendum B)
};

export function getStageColor(stageStatus) {
  return STAGE_THEMES[stageStatus]?.color ?? 'var(--gold)';
}

export function getStageLight(stageStatus) {
  return STAGE_THEMES[stageStatus]?.light ?? '#fdf8f0';
}

export function getDaysInStage(stageStartedAt) {
  if (!stageStartedAt) return null;
  const ms = Date.now() - new Date(stageStartedAt).getTime();
  return Math.max(1, Math.floor(ms / 86400000));
}
